<template>
  <div id="app">
    <el-container>
      <el-header>
        <router-link class="logo" to="/">
          <img src="../public/img/logo.png" alt="江苏道鼎升工程检测有限公司 logo" />
        </router-link>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          :router="true"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/services">对公服务</el-menu-item>
          <el-submenu index="service-menu">
            <template slot="title">核心服务</template>
            <el-menu-item
              v-for="service in services"
              :key="service.slug"
              :index="service.path"
            >
              {{ service.shortTitle }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/owner-inspection">业主验房</el-menu-item>
          <el-menu-item index="/cases">服务案例</el-menu-item>
          <el-menu-item index="/knowledge">知识库</el-menu-item>
          <el-menu-item index="/goin">关于我们</el-menu-item>
          <el-menu-item index="/honor">资质资料</el-menu-item>
          <el-menu-item index="/download">联系我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
    <div class="mobile-contact-bar" aria-label="移动端咨询入口">
      <a :href="'tel:' + company.phone">电话咨询</a>
      <router-link :to="{ path: '/', hash: '#lead-form' }">提交需求</router-link>
    </div>
  </div>
</template>

<script>
import { companyInfo, publicServices } from "./data/services";

export default {
  data() {
    return {
      company: companyInfo,
      services: publicServices,
      defaultActive: "/"
    };
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(path) {
        if (path.indexOf("/services/") === 0) {
          this.defaultActive = path;
          return;
        }
        if (path.indexOf("/cases/") === 0) {
          this.defaultActive = "/cases";
          return;
        }
        if (path.indexOf("/knowledge/") === 0) {
          this.defaultActive = "/knowledge";
          return;
        }
        this.defaultActive = path;
      }
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html,
body {
  min-height: 100%;
}

body {
  background: #f4f6f8;
}

#app {
  font-family: "Avenir", Helvetica, Arial, "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2d3d;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: min(1240px, calc(100% - 32px));
  height: 68px !important;
  margin: 0 auto;
  padding: 0 !important;
  background: #fff;

  .logo {
    display: inline-flex;
    align-items: center;
    width: 230px;
    min-width: 180px;
    text-decoration: none;

    img {
      width: 100%;
      display: block;
    }
  }

  .el-menu-demo {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    border-bottom: none;
    min-width: 0;
  }

  .el-menu--horizontal > .el-menu-item,
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 68px;
    line-height: 68px;
    color: #24323d;
  }

  .el-menu--horizontal > .el-menu-item.is-active,
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    color: #0c4a6e;
    border-bottom-color: #c8872a;
  }
}

.el-main {
  padding: 0 !important;
}

.beian {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  padding: 22px 16px;
  color: #64727d;
  font-size: 13px;
  text-align: center;

  a {
    color: #64727d;
    text-decoration: none;

    &:hover {
      color: #0c4a6e;
    }
  }
}

.mobile-contact-bar {
  display: none;
}

@media (max-width: 1180px) {
  .el-header {
    height: auto !important;
    flex-direction: column;
    align-items: stretch;
    padding: 10px 0 !important;

    .logo {
      width: 220px;
      margin: 0 auto 8px;
    }

    .el-menu-demo {
      justify-content: flex-start;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
    }

    .el-menu--horizontal > .el-menu-item,
    .el-menu--horizontal > .el-submenu .el-submenu__title {
      height: 52px;
      line-height: 52px;
    }
  }
}

@media (max-width: 640px) {
  body {
    padding-bottom: 72px;
  }

  .el-header {
    width: min(100% - 20px, 1240px);
    padding: 6px 0 !important;

    .logo {
      width: 166px;
      margin-bottom: 4px;
    }

    .el-menu--horizontal > .el-menu-item,
    .el-menu--horizontal > .el-submenu .el-submenu__title {
      height: 42px;
      line-height: 42px;
    }
  }

  .el-menu--horizontal > .el-menu-item,
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    padding: 0 10px;
    font-size: 13px;
  }

  .mobile-contact-bar {
    position: fixed;
    left: 12px;
    right: 12px;
    bottom: 12px;
    z-index: 2000;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 12px 30px rgba(15, 49, 59, 0.22);
  }

  .mobile-contact-bar a {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    border-radius: 4px;
    background: #0c4a6e;
    color: #fff;
    text-decoration: none;
    font-weight: 700;
  }

  .mobile-contact-bar a:last-child {
    background: #c8872a;
  }
}
</style>
